import APIService from "./APIService";

/**
 * Service for handling Scam Detector API operations
 *
 * Expected response format:
 * {
 *   "success": true/false,
 *   "message": "Descriptive message",
 *   "data": { ... }
 * }
 */
const ScamDetectorAPI = {
  /**
   * Analyze email content for scam detection using default provider
   * Uses the user-specific endpoint that requires JWT authentication
   * @param {Object} emailContent - Email content to analyze
   * @returns {Promise} Promise that resolves with analysis result
   */
  analyzeEmail: async (emailContent) => {
    try {
      console.log(
        "[ScamDetectorAPI] Analyzing email with default provider:",
        emailContent,
      );
      const response = await APIService.post(
        "/api/v1/scam/detector/email/analyze-user",
        emailContent,
      );
      console.log("[ScamDetectorAPI] Analysis response:", response);
      return response;
    } catch (error) {
      console.error("[ScamDetectorAPI] Error analyzing email:", error);
      throw error;
    }
  },

  /**
   * Analyze social media content for scam detection using default provider
   * @param {Object} socialMediaContent - Social media content to analyze
   * @returns {Promise} Promise that resolves with analysis result
   */
  analyzeSocialMedia: async (socialMediaContent) => {
    try {
      console.log(
        "[ScamDetectorAPI] Analyzing social media with default provider:",
        socialMediaContent,
      );
      const response = await APIService.post(
        "/api/v1/scam/detector/social-media/analyze",
        socialMediaContent,
      );
      console.log("[ScamDetectorAPI] Analysis response:", response);
      return response;
    } catch (error) {
      console.error("[ScamDetectorAPI] Error analyzing social media:", error);
      throw error;
    }
  },

  /**
   * Analyze text and/or phone number for scam detection and risk assessment
   * @param {string} phoneNumber - Phone number to analyze (optional)
   * @param {string} textContent - Text content to analyze (optional)
   * @returns {Promise} Promise that resolves with analysis result
   */
  analyzeText: async (
    phoneNumber = null,
    textContent = null,
    userContext = null,
  ) => {
    try {
      // Create request parameters for backend
      const params = new URLSearchParams();
      if (phoneNumber && phoneNumber.trim()) {
        params.append("phoneNumber", phoneNumber.trim());
      }
      if (textContent && textContent.trim()) {
        params.append("textMessage", textContent.trim());
      }
      if (userContext && userContext.trim()) {
        params.append("userContext", userContext.trim());
      }

      const response = await APIService.post(
        "/api/v1/scam/detector/sms/analyze",
        params,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          timeout: 60000, // 60s — Claude AI analysis can take up to ~30s
        },
      );

      return response;
    } catch (error) {
      console.error("[ScamDetectorAPI] Error analyzing text:", error);
      throw error;
    }
  },
};

export default ScamDetectorAPI;
